(function () {
  'use strict';

  function initLookbook(section) {
    var track = section.querySelector('[data-lookbook-track]');
    var dotsWrap = section.querySelector('[data-lookbook-dots]');
    var prevBtn = section.querySelector('[data-lookbook-prev]');
    var nextBtn = section.querySelector('[data-lookbook-next]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-lookbook-slide]'));
    if (!slides.length) return;

    // Build dots
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lookbook__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          scrollToSlide(index);
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;
    }

    function scrollToSlide(index) {
      var target = slides[index];
      if (!target) return;
      track.scrollTo({
        left: target.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }

    function getActiveIndex() {
      var trackRect = track.getBoundingClientRect();
      var closestIndex = 0;
      var closestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var rect = slide.getBoundingClientRect();
        var distance = Math.abs(rect.left - trackRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    }

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(function () {
        setActive(getActiveIndex());
      }, 100);
    }, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var current = getActiveIndex();
        scrollToSlide(Math.max(current - 1, 0));
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var current = getActiveIndex();
        scrollToSlide(Math.min(current + 1, slides.length - 1));
      });
    }

    setActive(0);
  }

  function initAll() {
    document.querySelectorAll('[data-lookbook]').forEach(initLookbook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is added/re-rendered in the Theme Editor
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-lookbook]');
    if (section) initLookbook(section);
  });
})();